import React from 'react';

import {
  Button,
  ButtonProps,
  MenuItem,
  MenuItemProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

export const MySubmitButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      {...props}
      w="100%"
      variant="solid"
      bg="black"
      color="#fff"
      width="100%"
      height="44px"
      fontWeight="400"
      borderRadius="3px"
      fontSize="19px"
      letterSpacing="0.3px"
      _hover={{ bg: '#141414' }}
      _active={{ bg: '#2b2b2b' }}
    >
      {props.children}
    </Button>
  );
};

export const MyMenuItem: React.FC<MenuItemProps> = (props) => (
  <MenuItem
    _hover={{ backgroundColor: '#f0f0f0' }}
    _active={{ backgroundColor: '#dededed4' }}
    _focus={{ backgroundColor: '#f0f0f0' }}
    {...props}
  >
    {props.children}
  </MenuItem>
);

interface MyModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  bodyText: string;
  submitBtnText: string;
  cancelBtnText: string;
  onSubmitBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  isSubmitBtnLoading?: boolean;
}

export const MyModal: React.FC<MyModalProps> = ({
  isOpen,
  onClose,
  headerText,
  bodyText,
  submitBtnText,
  cancelBtnText,
  onSubmitBtnClick,
  isSubmitBtnLoading,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} blockScrollOnMount={true}>
    <ModalOverlay />
    <ModalContent
      borderRadius="3px"
      mt={'0'}
      mb={'0'}
      width={'90%'}
      bottom="21px"
      position={'absolute'}
    >
      <ModalHeader paddingBottom="0px" paddingLeft="17px" fontWeight="400">
        {headerText}
      </ModalHeader>
      <ModalBody paddingLeft="17px" color={'#888'}>
        {bodyText}
      </ModalBody>

      <ModalFooter h={'70px'}>
        {/* <ModalFooter h={'60px'} bgColor={'red'}> */}
        <Button
          mr={3}
          onClick={onClose}
          padding={'0 20px'}
          height="34px"
          variant="solid"
          bg="#fff"
          border={'solid 1px #eee'}
          color="#111"
          fontWeight="400"
          borderRadius="3px"
          fontSize="15px"
          letterSpacing="0.3px"
          _hover={{ bg: '#fafafa' }}
          _active={{ bg: '#f0f0f0' }}
        >
          {cancelBtnText}
        </Button>

        <Button
          padding={'0 20px'}
          height="34px"
          variant="solid"
          bg="black"
          color="#fff"
          fontWeight="400"
          borderRadius="3px"
          fontSize="15px"
          letterSpacing="0.3px"
          _hover={{ bg: '#141414' }}
          _active={{ bg: '#2b2b2b' }}
          onClick={onSubmitBtnClick}
          isLoading={isSubmitBtnLoading}
        >
          {submitBtnText}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
